export default function(btn){
	const old_posts = document.querySelector('.old_posts')
	if (old_posts) {
		btn.addEventListener('click', () => {
			old_posts.classList.add('active')
			btn.classList.add('hidden')
		})		
	}

}